import { ItemDetail, ItemFilters } from "@/types/inventory/item";
import { Page } from "@/types/pagination";

import { listItemGroups, listItems } from "./item";

export const itemQueryKeys = {
  all: ["inventory", "items"] as const,
  list: (filters?: ItemFilters) =>
    [...itemQueryKeys.all, "list", filters] as const,
  listPaginated: (filters?: ItemFilters) =>
    [...itemQueryKeys.all, "list-paginated", filters] as const,
  groups: (filters?: ItemFilters) =>
    [...itemQueryKeys.all, "groups", filters] as const,
  search: (name: string) => [...itemQueryKeys.all, "search", name] as const,
};

export const itemQueryOptions = {
  list: (filters?: ItemFilters) => ({
    queryKey: itemQueryKeys.list(filters),
    queryFn: () => listItems(filters),
    select: (data: Page<ItemDetail> | null) => data?.data ?? [],
    staleTime: 1000 * 60 * 5, // 5 minutes
  }),
  listPaginated: (filters?: ItemFilters) => ({
    queryKey: itemQueryKeys.listPaginated(filters),
    queryFn: () => listItems(filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
  }),
  groups: (filters?: ItemFilters) => ({
    queryKey: itemQueryKeys.groups(filters),
    queryFn: () => listItemGroups(filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
  }),
};
